export const PAST_SEVEN = { value: 7, display: 'Past 7' };
export const PAST_FOURTEEN = { value: 14, display: 'Past 14' };
export const PAST_TWENTY_ONE = { value: 21, display: 'Past 21' };
